import type { FC } from "react";

import { Typography } from "@aviary";

import { title as titleStyles } from "./SignUpModalTitle.styles";

interface Props {
  title: string;
}

const SignUpModalTitle: FC<Props> = ({ title }) => {
  return (
    <Typography type="h1" sizeOverride="h2" css={titleStyles}>
      {title}
    </Typography>
  );
};

export { SignUpModalTitle };
